module.exports = __webpack_public_path__ + "static/img/cgal10.585b494.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/cgal10.png
// module id = CHMQ
// module chunks = 1